<div class="cb-input-wrapper">
  <label>{{label}}</label>
  <p-multiSelect [placeholder]="placeholder ?? ''" [filter]="false" [options]="options" [(ngModel)]="value"
    optionLabel="label" optionValue="value" (onChange)="onChange.emit($event)" [disabled]="disabled"
    [appendTo]="appendTo" [class.error]="error">
  </p-multiSelect>
</div>
